"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToolbarUI = void 0;
var react_1 = __importStar(require("react"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Models_1 = require("@CommonFrontend/ContentTokens/Models");
var EventUtils_1 = require("@CommonFrontend/Utils/EventUtils");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var TextTypeMenu_1 = require("./Menus/TextTypeMenu");
var ListItemMenu_1 = require("./Menus/ListItemMenu");
var FontSize_1 = require("./Menus/FontSize");
var TextColorMenu_1 = require("./Menus/TextColorMenu");
var TextAlignment_1 = require("./Menus/TextAlignment");
var TextPropagationMenu_1 = require("./Menus/TextPropagationMenu");
var Utils_1 = require("Project/QwilrEditor/Utils");
var StyleableBehaviours_1 = require("Project/QwilrEditor/Behaviours/Styleable/StyleableBehaviours");
var FilterToolbarFeatures_1 = require("./FilterToolbarFeatures");
var FeatureButtons_1 = require("./FeatureButtons");
var GetSelectedTextColor_1 = require("./Menus/GetSelectedTextColor");
var GetStyleForPropagation_1 = require("./Menus/GetStyleForPropagation");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ContextualStylesMenu_1 = require("./Menus/ContextualStylesMenu");
var styles = __importStar(require("./TextToolbarUI.css"));
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var inversify_react_1 = require("inversify-react");
var GetComputedStyleProperty_1 = require("./GetComputedStyleProperty");
var ScrollLock_1 = __importDefault(require("Project/Utils/ScrollLock"));
var Styleable_1 = require("Project/QwilrEditor/WidgetRegistry/Utils/Styleable");
var TextToolbarUI = function (_a) {
    var toolbarFeatures = _a.toolbarFeatures, widgetManager = _a.widgetManager, blockStore = _a.blockStore, selectedTextWidgets = _a.selectedTextWidgets, onToolbarTopLevelFocus = _a.onToolbarTopLevelFocus, hideToolbar = _a.hideToolbar, anchorRef = _a.anchorRef;
    var editor = (0, slate_react_1.useSlate)();
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var stylePermissionsStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var _b = useInputFocusHack(), inputHackElement = _b.inputHackElement, inputHackFocusHandler = _b.inputHackFocusHandler;
    var containerElementType = (0, Utils_1.getNearestContainerAncestor)(editor);
    var filteredToolbarFeatures = (0, FilterToolbarFeatures_1.filterToolbarFeatures)(toolbarFeatures, containerElementType, blockStore.isSavedBlock);
    var contextualStylesAllowed = (0, Styleable_1.canAccessContextualStyles)(usingFeature, editor, stylePermissionsStore);
    var alignment = (0, GetComputedStyleProperty_1.getComputedStyleProperty)("alignable", selectedTextWidgets);
    var fontSize = (0, GetComputedStyleProperty_1.getComputedStyleProperty)("fontSize", selectedTextWidgets);
    var color = (0, GetSelectedTextColor_1.getSelectedTextColor)(editor, selectedTextWidgets);
    var styleModified = selectedTextWidgets.some(function (_a) {
        var overrides = _a.overrides;
        return Object.keys(overrides).length > 0;
    }) || color.containsOverrides;
    var hasPermissions = stylePermissionsStore.allowStyle(Types_1.StyleAccessType.Text);
    function onToolbarEvent(eventData) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("toolbar", eventData));
    }
    function transformStyleProperty(type, transform) {
        var e_1, _a;
        try {
            for (var selectedTextWidgets_1 = __values(selectedTextWidgets), selectedTextWidgets_1_1 = selectedTextWidgets_1.next(); !selectedTextWidgets_1_1.done; selectedTextWidgets_1_1 = selectedTextWidgets_1.next()) {
                var _b = selectedTextWidgets_1_1.value, element = _b.element, style = _b.style, styleableConfig = _b.styleableConfig;
                var styleableProperty = styleableConfig.properties.find(function (s) { return s.type === type; });
                if (!styleableProperty) {
                    continue;
                }
                var value = (0, lodash_1.get)(style, styleableProperty.path);
                var newValue = transform(value);
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("styleable", {
                    action: StyleableBehaviours_1.StyleableAction.UpdateElementStyles,
                    path: widgetManager.getPath(element),
                    style: [{ pathToUpdate: styleableProperty.path, value: newValue }],
                }));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (selectedTextWidgets_1_1 && !selectedTextWidgets_1_1.done && (_a = selectedTextWidgets_1.return)) _a.call(selectedTextWidgets_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    function setStyleProperty(type, val) {
        transformStyleProperty(type, function () { return val; });
    }
    function renderButton(toolbarFeature, _a) {
        var _b = _a === void 0 ? { hideOnClick: false } : _a, hideOnClick = _b.hideOnClick;
        var isFeatureAllowed = filteredToolbarFeatures.some(function (f) { return f === toolbarFeature; });
        if (!isFeatureAllowed)
            return null;
        var toolbarButtonConfig = FeatureButtons_1.textToolbarFeatureButtons[toolbarFeature];
        var isSelected = toolbarButtonConfig.isActive(editor);
        return (react_1.default.createElement(TopLevelButton, { buttonConfig: toolbarButtonConfig, onToolbarEvent: function (eventData) {
                onToolbarEvent(eventData);
                if (hideOnClick) {
                    hideToolbar();
                }
            }, isSelected: isSelected }));
    }
    var onResetStyle = function () {
        var e_2, _a;
        try {
            for (var selectedTextWidgets_2 = __values(selectedTextWidgets), selectedTextWidgets_2_1 = selectedTextWidgets_2.next(); !selectedTextWidgets_2_1.done; selectedTextWidgets_2_1 = selectedTextWidgets_2.next()) {
                var element = selectedTextWidgets_2_1.value.element;
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("styleable", {
                    action: StyleableBehaviours_1.StyleableAction.ClearElementStyles,
                    path: widgetManager.getPath(element),
                }));
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (selectedTextWidgets_2_1 && !selectedTextWidgets_2_1.done && (_a = selectedTextWidgets_2.return)) _a.call(selectedTextWidgets_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        onToolbarEvent({ action: "textColorRemove", scope: "selection" });
    };
    var propagationStyle = (0, GetStyleForPropagation_1.getStyleForPropagation)(selectedTextWidgets, color);
    var selectionIncludesLinks = !!editor.selection &&
        !!slate_1.Editor.nodes(editor, {
            match: function (node) { return slate_1.Element.isElement(node) && node.type === Models_1.InlineType.Link; },
        }).next().value;
    var onPropagateStyle = function () {
        if (!propagationStyle) {
            return;
        }
        var elementType = propagationStyle.elementType, styleableConfig = propagationStyle.styleableConfig, overrides = propagationStyle.overrides, hasTextColorOverride = propagationStyle.hasTextColorOverride;
        var blockStyle = blockStore.blockStyleStore.getElementStyle(styleableConfig.styleKey);
        var nextBlockStyle = (0, lodash_1.merge)({}, blockStyle, overrides);
        blockStore.blockStyleStore.setElementStyle(styleableConfig.styleKey, nextBlockStyle);
        if (selectionIncludesLinks && hasTextColorOverride) {
            var linkBlockStyle = blockStore.blockStyleStore.getElementStyle("link");
            var nextLinkStyle = (0, lodash_1.merge)({}, linkBlockStyle, { color: overrides["color"] });
            blockStore.blockStyleStore.setElementStyle("link", nextLinkStyle);
        }
        if (propagationStyle.fontSizePropagatesToParagraph) {
            var nextParagraphStyles = (0, lodash_1.cloneDeep)(blockStore.blockStyleStore.getElementStyle("p"));
            nextParagraphStyles["size"] = propagationStyle.fontSizePropagatesToParagraph.size;
            blockStore.blockStyleStore.setElementStyle("p", nextParagraphStyles);
        }
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("styleable", {
            action: StyleableBehaviours_1.StyleableAction.PropagateElementStyle,
            type: elementType,
        }));
        serverTelemetry.sendOverridesTelemetry();
        if (hasTextColorOverride) {
            onToolbarEvent({ action: "textColorRemove", scope: "all", widgetType: elementType });
        }
    };
    var onPropagateStyleWithScrollLock = function () {
        if (anchorRef.current) {
            (0, ScrollLock_1.default)(anchorRef.current, onPropagateStyle);
        }
        else {
            onPropagateStyle();
        }
    };
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 10 }, function () { return (react_1.default.createElement(kaleidoscope_1.Toolbar, { className: styles.wrapper, visible: true, positionType: kaleidoscope_1.ToolbarPositionType.None },
        react_1.default.createElement("div", { onFocus: function (e) {
                inputHackFocusHandler(e);
                onToolbarTopLevelFocus();
            } },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxs" },
                react_1.default.createElement(TextTypeMenu_1.TextTypeMenu, { selectedTextWidgets: selectedTextWidgets, containerElementType: containerElementType, onToolbarEvent: onToolbarEvent }),
                contextualStylesAllowed && fontSize.isAllowed && canChangeFontSizeOverSelection(selectedTextWidgets) && (react_1.default.createElement(FontSize_1.FontSize, { value: fontSize.value ? fontSize.value : null, min: fontSize.property.min, max: fontSize.property.max, onChange: function (v) { return setStyleProperty("fontSize", v); }, onScale: function (map) { return transformStyleProperty("fontSize", map); } })),
                contextualStylesAllowed && (react_1.default.createElement(TextColorMenu_1.TextColorMenu, { value: color.color ? color.color : null, onChange: function (color) {
                        return onToolbarEvent({
                            action: "textColorChange",
                            color: (0, GetBlockStyle_1.convertColorToColorObj)(color),
                        });
                    } })),
                renderButton(EditorTypes_1.MarkType.Bold),
                renderButton(EditorTypes_1.MarkType.Italic),
                renderButton(EditorTypes_1.MarkType.Strikethrough),
                contextualStylesAllowed && alignment.isAllowed && (react_1.default.createElement(TextAlignment_1.TextAlignment, { value: alignment.value, onValueChange: function (v) { return setStyleProperty("alignable", v); } })),
                renderButton(Models_1.InlineType.Link, { hideOnClick: true }),
                react_1.default.createElement(ListItemMenu_1.ListItemMenu, { selectedTextWidgets: selectedTextWidgets, containerElementType: containerElementType, onToolbarEvent: onToolbarEvent }),
                renderButton(EditorTypes_1.MarkType.Comment, { hideOnClick: true }),
                styleModified && hasPermissions && (react_1.default.createElement(TextPropagationMenu_1.TextPropagationMenu, { propagateStyleDisabled: propagationStyle === undefined, onPropagateStyle: onPropagateStyleWithScrollLock, onResetStyle: onResetStyle })),
                contextualStylesAllowed && (0, ContextualStylesMenu_1.maybeRenderContextualStylesMenu)({ selectedTextWidgets: selectedTextWidgets, widgetManager: widgetManager }),
                inputHackElement)))); }));
};
exports.TextToolbarUI = TextToolbarUI;
function useInputFocusHack() {
    var focusHackInputRef = (0, react_1.useRef)(null);
    var hasRunInputFocusHack = (0, react_1.useRef)(false);
    var onFocusHandler = function (e) {
        var _a, _b;
        if (!hasRunInputFocusHack.current) {
            hasRunInputFocusHack.current = true;
            if (e.target.tagName === "INPUT")
                return;
            (_a = focusHackInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            (_b = focusHackInputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
        }
    };
    return {
        inputHackElement: (react_1.default.createElement("input", { className: styles.focusHackInput, ref: focusHackInputRef, tabIndex: -1, "aria-hidden": true, readOnly: true })),
        inputHackFocusHandler: onFocusHandler,
    };
}
var TopLevelButton = function (_a) {
    var buttonConfig = _a.buttonConfig, onToolbarEvent = _a.onToolbarEvent, isSelected = _a.isSelected;
    return (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: buttonConfig.icon, onClick: function (mouseEvent) {
            if (!(0, EventUtils_1.isPrimaryButton)(mouseEvent)) {
                return;
            }
            var eventData = { button: buttonConfig.eventButtonType };
            onToolbarEvent(eventData);
        }, selected: isSelected, "aria-label": buttonConfig.displayName, tooltip: { content: buttonConfig.displayName } }));
};
function canChangeFontSizeOverSelection(selectedTextWidgets) {
    var elementTypes = new Set(selectedTextWidgets.map(function (_a) {
        var element = _a.element;
        return element.type;
    }));
    if (elementTypes.size === 1)
        return true;
    return elementTypes.size === 2 && elementTypes.has("paragraph") && elementTypes.has("listItem");
}
